import { Box, Grid, Typography } from "@mui/material";

export interface SubAreaRegionsProps {
  name: string;
  subRegions: string[];
  handleOnClick?: (value: string, label: string, storeNum: number) => void;
}

function SubAreaRegions({
  name,
  subRegions,
  handleOnClick,
}: SubAreaRegionsProps) {
  return (
    <Grid container display="flex" my={2}>
      <Grid item xs={3} display="flex" alignItems="start">
        <Typography
          whiteSpace="nowrap"
          variant="h6"
          fontWeight="bold"
          sx={{ marginRight: 2, display: "flex" }}
        >
          {name}
        </Typography>
      </Grid>
      <Grid item xs={9} display="flex" flexWrap="wrap">
        {subRegions.map((e) => (
          <Typography
            color="#397bbe"
            variant="body1"
            sx={{
              mx: 1,
              cursor: "pointer",
              "&:hover": {
                color: "primary.main",
              },
            }}
            // onClick={handleOnClick && handleOnClick(name, 3000)}
          >
            {e}
          </Typography>
        ))}
      </Grid>
    </Grid>
  );
}

export default SubAreaRegions;
